import React from 'react'
import { ChevronLeft24, ChevronRight24 } from '@carbon/icons-react'
import { Button } from '../../Button'

const ArrowsButtons = ({ arrowsConfig = {} }) => {
  const {
    prevDisabled,
    onPrevClick,
    onNextClick,
    nextDisabled,
    prevDescription,
    nextDescription,
    size
  } = arrowsConfig

  return (
    <div className='arrows-buttons'>
      <Button
        kind='tertiary'
        renderIcon={ChevronLeft24}
        onClick={onPrevClick}
        disabled={prevDisabled}
        size={size || 'default'}
        iconDescription={prevDescription || 'PREVIOUS'}
      />
      <Button
        kind='tertiary'
        renderIcon={ChevronRight24}
        onClick={onNextClick}
        disabled={nextDisabled}
        size={size || 'default'}
        iconDescription={nextDescription || 'NEXT'}
      />
    </div>
  )
}

export default React.memo(ArrowsButtons)
